@if (loadingCategories$ | async) {
  <div class="text-center my-3">
    <app-loading></app-loading>
  </div>
}

@let isArabic = isArabic$ | async;

<div class="d-flex align-items-baseline">
  <i
    class="bi h2 cursor-poiner text-primary bg-dark rounded"
    [ngClass]="isArabic ? 'bi-arrow-right-short ms-2' : 'bi-arrow-left-short me-2'"
    (click)="goBack()"
  ></i>
  <h2 class="mb-0">
    {{ 'PROPERTY_SEARCH_TITLE' | translate }}
  </h2>
</div>

@if (categories$ | async; as categories) {
  <form
    searchCountSummary="REAL_ESTATE"
    [countForm]="searchForm"
    [countFeatures]="advancedVisible"
    #liveCounts="searchCounts"
    [formGroup]="searchForm"
    (ngSubmit)="onSearch()"
    class="p-4 bg-dark rounded"
  >
    <!-- Basic search fields -->
    <div class="row mb-3">
      <div class="col-lg-6 col-md-12 pb-3">
        <div
          class="up-in-toggle search-sale-toggle"
          [ngClass]="isArabic ? 'float-end' : 'float-start'"
        >
          <input
            type="radio"
            id="switch_right"
            name="isForRent"
            [value]="true"
            formControlName="isForRent"
            (click)="toggleIsRent(true)"
          />
          <label for="switch_right"
            ><span class="sale-option-label">{{ 'FOR_RENT' | translate }}</span>
            <small
              class="search-inline-count px-2"
              [style.visibility]="
                liveCounts.count('isForRent', true) === undefined ? 'hidden' : 'visible'
              "
              >({{ liveCounts.count('isForRent', true) }})</small
            ></label
          >
          <input
            type="radio"
            id="switch_left"
            name="isForRent"
            [value]="false"
            formControlName="isForRent"
            (click)="toggleIsRent(false)"
          />
          <label for="switch_left"
            ><span class="sale-option-label">{{ 'FOR_SALE' | translate }}</span>
            <small
              class="search-inline-count px-2"
              [style.visibility]="
                liveCounts.count('isForRent', false) === undefined ? 'hidden' : 'visible'
              "
              >({{ liveCounts.count('isForRent', false) }})</small
            ></label
          >
        </div>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="propertyTypes"
          facetDomain="REAL_ESTATE"
          [facetForm]="searchForm"
          #propertyTypes
          class="required multi-line-select"
          [items]="categories.propertyTypes"
          formControlName="propertyTypes"
          placeholder="{{ 'PROPERTY_TYPE' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="typeOfPossessions"
          facetDomain="REAL_ESTATE"
          [facetForm]="searchForm"
          #typeOfPossessions
          class="required multi-line-select"
          [items]="categories.typeOfPossessions"
          formControlName="typeOfPossessions"
          placeholder="{{ 'PROPERTY_NEW_SELECT_POSSESSION_TYPE' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <app-dropdown-checkbox-select
          searchFacet="conditions"
          facetDomain="REAL_ESTATE"
          [facetForm]="searchForm"
          #propertyConditions
          class="required multi-line-select"
          [items]="categories.propertyConditions"
          formControlName="conditions"
          placeholder="{{ 'PROPERTY_NEW_SELECT_CONDITION' | translate }}"
          [selectableGroup]="false"
        >
        </app-dropdown-checkbox-select>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-4 text-light range-count-heading"
            ><span>{{ 'PROPERTY_ADD_YEAR' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('year') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('year') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT' | translate: { count: liveCounts.rangeTotal('year') })
              "
              >({{ liveCounts.rangeTotal('year') ?? '' }})</small
            ></span
          >
          <div class="col-4">
            <input
              type="number"
              inputmode="numeric"
              id="yearFrom"
              formControlName="yearFrom"
              class="form-control no-spinner"
              placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
              highlightIfHasValue
              emptyToUndefined
            />
          </div>
          <div class="col-4">
            <input
              type="number"
              inputmode="numeric"
              id="yearTo"
              formControlName="yearTo"
              class="form-control no-spinner"
              placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
              highlightIfHasValue
              emptyToUndefined
            />
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-4 text-light range-count-heading"
            ><span>{{ 'PROPERTY_ADD_PRICE' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('price') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('price') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT' | translate: { count: liveCounts.rangeTotal('price') })
              "
              >({{ liveCounts.rangeTotal('price') ?? '' }})</small
            ></span
          >
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="priceFrom"
                formControlName="priceFrom"
                class="form-control no-spinner"
                min="0"
                max="50000000"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">$</span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="priceTo"
                formControlName="priceTo"
                class="form-control no-spinner"
                min="10"
                max="50000000"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">$</span>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <app-tri-state-checkbox formControlName="isInstallmentAvailable"
            [matchCount]="liveCounts.count('isInstallmentAvailable')" [label]="'PAY_IN_INSTALLMENTS' | translate" />
        </div>
        <label class="d-flex align-items-center gap-2 text-light mt-2">
          <input type="checkbox" class="form-check-input m-0" formControlName="onlyWithPrice" />
          <span>{{ 'SEARCH_ONLY_WITH_PRICE' | translate }}</span>
        </label>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-4 text-light range-count-heading"
            ><span>{{ 'PROPERTY_ADD_FLOOR_A' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('floorArea') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('floorArea') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT'
                    | translate: { count: liveCounts.rangeTotal('floorArea') })
              "
              >({{ liveCounts.rangeTotal('floorArea') ?? '' }})</small
            ></span
          >
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="floorAreaFrom"
                formControlName="floorAreaFrom"
                class="form-control no-spinner"
                min="10"
                max="1050"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">{{ 'M2' | translate }}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="floorAreaTo"
                formControlName="floorAreaTo"
                class="form-control no-spinner"
                min="10"
                max="1050"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">{{ 'M2' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 pb-3">
        <div class="row g-2 align-items-center">
          <span class="col-4 text-light range-count-heading"
            ><span>{{ 'PROPERTY_ADD_LAND_A' | translate }}</span
            ><small
              class="search-range-count"
              [style.visibility]="
                liveCounts.rangeTotal('landArea') === undefined ? 'hidden' : 'visible'
              "
              [attr.title]="
                liveCounts.rangeTotal('landArea') === undefined
                  ? null
                  : ('SEARCH_MATCHING_COUNT'
                    | translate: { count: liveCounts.rangeTotal('landArea') })
              "
              >({{ liveCounts.rangeTotal('landArea') ?? '' }})</small
            ></span
          >
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="landAreaFrom"
                formControlName="landAreaFrom"
                class="form-control no-spinner"
                min="10"
                max="1050"
                placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">{{ 'M2' | translate }}</span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                id="landAreaTo"
                formControlName="landAreaTo"
                class="form-control no-spinner"
                min="10"
                max="1050"
                placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                kiloFormat
                highlightIfHasValue
                emptyToUndefined
              />
              <span class="input-group-text">{{ 'M2' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Advanced fields (collapsed by default) -->
      @if (advancedVisible) {
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'PROPERTY_NEW_FLOOR_N' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('floorNumber') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('floorNumber') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('floorNumber') })
                "
                >({{ liveCounts.rangeTotal('floorNumber') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="text"
                  id="floorNumberFrom"
                  formControlName="floorNumberFrom"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text"
                  ><i class="bi bi-building-fill-exclamation"></i
                ></span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="text"
                  id="floorNumberTo"
                  formControlName="floorNumberTo"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text"
                  ><i class="bi bi-building-fill-exclamation"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'PROPERTY_NEW_N_FLOORS' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('numberOfFloors') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('numberOfFloors') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('numberOfFloors') })
                "
                >({{ liveCounts.rangeTotal('numberOfFloors') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="text"
                  id="numberOfFloorsFrom"
                  formControlName="numberOfFloorsFrom"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text"><i class="bi bi-building-fill-up"></i></span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="text"
                  id="numberOfFloorsTo"
                  formControlName="numberOfFloorsTo"
                  class="form-control no-spinner"
                  min="10"
                  max="1050"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  kiloFormat
                  highlightIfHasValue
                  emptyToUndefined
                />
                <span class="input-group-text"><i class="bi bi-building-fill-up"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'PROPERTY_NEW_ROOM' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('rooms') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('rooms') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('rooms') })
                "
                >({{ liveCounts.rangeTotal('rooms') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="roomsFrom"
                  formControlName="roomsFrom"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"><i class="bi bi-door-closed-fill"></i></span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="roomsTo"
                  formControlName="roomsTo"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"><i class="bi bi-door-closed-fill"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'PROPERTY_NEW_BEDROOM' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('bedrooms') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('bedrooms') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('bedrooms') })
                "
                >({{ liveCounts.rangeTotal('bedrooms') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="bedroomsFrom"
                  formControlName="bedroomsFrom"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"
                  ><img src="icons/bed.png" width="16" height="18"
                /></span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="bedroomsTo"
                  formControlName="bedroomsTo"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"
                  ><img src="icons/bed.png" width="16" height="18"
                /></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <div class="row g-2 align-items-center">
            <span class="col-4 text-light range-count-heading"
              ><span>{{ 'PROPERTY_NEW_BATHROOM' | translate }}</span
              ><small
                class="search-range-count"
                [style.visibility]="
                  liveCounts.rangeTotal('bathrooms') === undefined ? 'hidden' : 'visible'
                "
                [attr.title]="
                  liveCounts.rangeTotal('bathrooms') === undefined
                    ? null
                    : ('SEARCH_MATCHING_COUNT'
                      | translate: { count: liveCounts.rangeTotal('bathrooms') })
                "
                >({{ liveCounts.rangeTotal('bathrooms') ?? '' }})</small
              ></span
            >
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="bathroomsFrom"
                  formControlName="bathroomsFrom"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MIN' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"
                  ><img src="icons/shower.png" width="16" height="18"
                /></span>
              </div>
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  id="bathroomsTo"
                  formControlName="bathroomsTo"
                  class="form-control"
                  min="1"
                  max="35"
                  placeholder="{{ 'CAR_SEARCH_MAX' | translate }}"
                  highlightIfHasValue
                />
                <span class="input-group-text"
                  ><img src="icons/shower.png" width="16" height="18"
                /></span>
              </div>
            </div>
          </div>
        </div>
        <div *hasRole="[roles.Admin, roles.Editor]" class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            searchFacet="statuses"
            facetDomain="REAL_ESTATE"
            [facetForm]="searchForm"
            #statuses
            class="required multi-line-select"
            [items]="categories.statuses"
            formControlName="statuses"
            placeholder="{{ 'CAR_SEARCH_STATUS' | translate }}"
            [selectableGroup]="false"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-12">
          <div class="row ms-4">
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasBalcony')"
                formControlName="hasBalcony"
                label="{{ 'PROPERTY_NEW_HAS_BALCONY' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasGarden')"
                formControlName="hasGarden"
                label="{{ 'PROPERTY_NEW_HAS_GARDEN' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasPool')"
                formControlName="hasPool"
                label="{{ 'PROPERTY_NEW_HAS_POOL' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasParking')"
                formControlName="hasParking"
                label="{{ 'PROPERTY_NEW_HAS_PARKING' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasLift')"
                formControlName="hasLift"
                label="{{ 'PROPERTY_NEW_HAS_LIFT' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('hasSolarEnergy')"
                formControlName="hasSolarEnergy"
                label="{{ 'PROPERTY_NEW_HAS_SOLAR_ENERGY' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
            <div
              class="col-12 col-md-4 col-sm-6 pb-3"
              [ngClass]="isArabic ? 'justify-content-between d-flex' : ''"
            >
              <app-tri-state-checkbox
                [matchCount]="liveCounts.count('isFurnished')"
                formControlName="isFurnished"
                label="{{ 'PROPERTY_NEW_IS_FURNISHED' | translate }}"
              >
              </app-tri-state-checkbox>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="col-md-12" [ngClass]="isArabic ? 'text-start' : 'text-end'">
      <button
        type="button"
        class="btn btn-primary bg-black text-primary mx-1"
        (click)="toggleAdvanced()"
      >
        {{ advancedVisible ? ('CAR_SEARCH_LESS' | translate) : ('CAR_SEARCH_MORE' | translate) }}
        @if (usedCriteriaCount > 0) {
          <span class="badge text-bg-primary"> {{ usedCriteriaCount }}</span>
        }
      </button>
      <button type="submit" class="btn btn-primary">{{ 'SEARCH_BUTTON' | translate }}</button>
      <button type="button" class="btn btn-secondary bg-black text-primary mx-1" (click)="reset()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="mt-2" [ngClass]="isArabic ? 'text-start' : 'text-end'">
      <app-save-search [form]="searchForm" domain="REAL_ESTATE" />
    </div>
  </form>
}

@if ((loadingResult$ | async) && !isMapView()) {
  <div role="status" class="text-center my-3"><app-loading></app-loading></div>
}
<div class="container-fluid">
  <app-property-search-result
    [mapParameters]="mapParameters"
    (mapChanged)="mapChanged($event)"
    (onListView)="clearMapData()"
  ></app-property-search-result>
</div>
